"use client";

import { Box, Typography } from "@mui/material";
import Link from "next/link";
import { getContactInfo, getExternalLinks } from "@/config/contact";

interface EnrollmentFooterProps {
    tenant: "nada" | "cada" | "atd";
}

export default function EnrollmentFooter({ tenant }: EnrollmentFooterProps) {
    const contactInfo = getContactInfo(tenant);
    const externalLinks = getExternalLinks(tenant);

    // Get tenant-specific org link text
    const getOrgLinkText = () => {
        switch (tenant) {
            case "cada":
                return "CADA.ca";
            case "atd":
                return "ATD.org";
            default:
                return "NADA.org";
        }
    };

    const getCopyrightText = () => {
        switch (tenant) {
            case "cada":
                return "Copyright © Canadian Automobile Dealers Association. All rights reserved.";
            case "atd":
                return "Copyright © American Truck Dealers. All rights reserved.";
            default:
                return "Copyright © National Automobile Dealers Association. All rights reserved.";
        }
    };

    return (
        <Box sx={{ mt: 8, pt: 4, borderTop: 1, borderColor: "divider", textAlign: "center" }}>
            <Typography variant="body2" sx={{ mb: 2 }}>
                <strong>
                    Questions? Email {contactInfo.email} or call {contactInfo.phone}
                </strong>
            </Typography>

            <Box
                sx={{ display: "flex", justifyContent: "center", gap: 3, flexWrap: "wrap", my: 3 }}
            >
                <Link href="/landing" style={{ textDecoration: "none", color: "inherit" }}>
                    Home
                </Link>
                <Link
                    href={externalLinks.dwsDatabase}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none", color: "inherit" }}
                >
                    DWS Dashboard
                </Link>
                <Link
                    href={externalLinks.orgWebsite}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none", color: "inherit" }}
                >
                    {getOrgLinkText()}
                </Link>
                <Link
                    href={externalLinks.aboutEsiq}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none", color: "inherit" }}
                >
                    About ESIQ
                </Link>
                <Link href="/contact" style={{ textDecoration: "none", color: "inherit" }}>
                    Contact Us
                </Link>
                {/* Hide Privacy Policy and FAQs for CADA (no legacy pages exist) */}
                {tenant !== "cada" && (
                    <>
                        <Link href="/privacy" style={{ textDecoration: "none", color: "inherit" }}>
                            Privacy Policy
                        </Link>
                        <Link href="/faqs" style={{ textDecoration: "none", color: "inherit" }}>
                            FAQs
                        </Link>
                    </>
                )}
            </Box>

            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                {getCopyrightText()}
            </Typography>
        </Box>
    );
}
